import { render } from "./CompModal.vue?vue&type=template&id=1bea1a7b"
import script from "./CompModal.vue?vue&type=script&lang=js"
export * from "./CompModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__